import { useContext } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import MasterAccessPage from './components/cms/access/MasterAccess'
import ManageRolePage from './components/cms/manage/role/ManageRole'
import CreateManageRolePage from './components/cms/manage/role/CreateManageRole'
import EditManageRolePage from './components/cms/manage/role/EditManageRole'
import ManageAccessPage from './components/cms/manage/role/access/ManageAccess'
import MasterRolePage from './components/cms/role/MasterRole'
import MasterUserPage from './components/cms/user/MasterUser'
import CreateSjLocation from './components/content/CreateSjLocation'
import OutboundHistory from './components/content/Outbound/History'
import { UserContext } from './context/userContext'
import ReceiveAtWarehousePlan from './pages/ArrivalPlan/ReceiveAtWarehousePlan'
import InboundHistoryPage from './pages/Inbound/History'
import PurchaseOrder from './pages/Inbound/PurchaseOrder'
import PurchaseOrderDetail from './pages/Inbound/PurchaseOrder/detail'
import PurchaseReceipt from './pages/Inbound/PurchaseReceipt'
import PurchaseReceiptCreate from './pages/Inbound/PurchaseReceipt/config'
import PurchaseReceiptDetail from './pages/Inbound/PurchaseReceipt/detail'
import PurchaseReceiptPlan from './pages/Inbound/PurchaseReceipt/plan'
import ReceiveMLDetail from './pages/Inbound/ReceiveML/Detail'
import ReceiveMLIndex from './pages/Inbound/ReceiveML/Index'
import Dashboard from './pages/Layout/Dashboard'
import DashboardMover from './pages/Layout/DashboardMover'
import HomeDashboard from './pages/Dashboard/Home'
import Login from './pages/Login'
import MasterArea from './pages/Master/Area'
import MasterBatchPage from './pages/Master/Batch'
import MasterBranch from './pages/Master/Branch'
import MasterCategory from './pages/Master/Categories'
import MasterBusinessUnit from './pages/Master/BusinessUnit'
import MasterDriver from './pages/Master/Driver'
import MasterExpedition from './pages/Master/Expedition'
import MasterItemPage from './pages/Master/Items'
import MasterItemDetailPage from './pages/Master/Items/detail'
import MasterPallete from './pages/Master/Pallete'
import MasterRackDetailPage from './pages/Master/RackDetail'
import MasterSector from './pages/Master/Sector'
import MasterStock from './pages/Master/Stock'
import DetailMasterRackDetailPage from './pages/Master/RackDetail/detail'
import MasterStockDetail from './pages/Master/Stock/detail'
import MasterVehicle from './pages/Master/Vehicle'
import MaterialRequest from './pages/MaterialRequest'
import CreateMaterialRequest from './pages/MaterialRequest/create'
import MaterialRequestDetail from './pages/MaterialRequest/detail'
import IndexMover from './pages/Mover/IndexMover'
import Notification from './pages/Notification'
import CustomerDeliveryPlan from './pages/Outbound/Customer'
import DeliveryConfirmation from './pages/Outbound/Dc'
import DeliveryConfirmationDetail from './pages/Outbound/Dc/detail'
import DeliveryHistory from './pages/Outbound/DeliveryHistory'
import DeliveryHistoryDetail from './pages/Outbound/DeliveryHistory/detail'
import OutboundPlan from './pages/Outbound/Plan'
import CreateOutboundPlan from './pages/Outbound/Plan/create'
import CreateDetailOutboundPlan from './pages/Outbound/Plan/createDetail'
import DetailOutboundPlan from './pages/Outbound/Plan/detail'
import SJ from './pages/Outbound/Sj'
import SlotLocation from './pages/Outbound/Sj/SlotLocation'
import CreateSj from './pages/Outbound/Sj/create'
import DetailSj from './pages/Outbound/Sj/detail'
import Transfer from './pages/Outbound/Transfer'
import SlotLocationTr from './pages/Outbound/Transfer/SlotLocation'
import DetailTransfer from './pages/Outbound/Transfer/detail'
import MapEditor from './pages/Settings/Map'
import UploadMap from './pages/Settings/Map/UploadMap'
import MasterRackPage from './pages/Settings/Rack'
import DetailRackPage from './pages/Settings/Rack/DetailRack'
import MasterStaging from './pages/Settings/Staging'
import WorkOrderPlan from './pages/WorkOrderPlan'
import SLotLocationWorkOrderPlan from './pages/WorkOrderPlan/SlotLocation'
import WorkOrderPlanDetail from './pages/WorkOrderPlan/detail'
import PrivateRoutes from './utils/PrivateRoutes'
import ProtectedMoverRoutes from './utils/ProtectedMoverRoutes'
import MasterStockQuarantineRejectPage from './pages/Master/Stock/QuarantineReject'
import SendToQuarantinePage from './pages/Master/Stock/SendToQuarantine'
import MaterialIssuePage from './pages/MaterialIssue'
import MaterialIssueDetailPage from './pages/MaterialIssue/detail'
import DisposalPage from './pages/Disposal'
import DisposalDetailPage from './pages/Disposal/detail'
import BeritaAcaraPage from './pages/BeritaAcara'
import CreateMaterialIssuePage from './pages/MaterialIssue/create'
import CreateDisposalPage from './pages/Disposal/create'
import { NotificationProvider } from './context/NotificationProvider'
import TransferAreaPage from './pages/Transfer/TransferArea'
import DetailTransferAreaPage from './pages/Transfer/TransferArea/detail'
import ItemIssue from './pages/ItemIssue/Index'
import CreateTransferItemIssuePage from './pages/ItemIssue/CreateTransfer'
import StockAdjustment from './pages/StockAdjustment'
import DetailStockAdjustment from './pages/StockAdjustment/detail'
import CreateStockAdjustment from './pages/StockAdjustment/create'
import TransferRackPage from './pages/Transfer/TransferRack'
import CreateTransferRackPage from './pages/Transfer/TransferRack/create'
import DetailTransferRackPage from './pages/Transfer/TransferRack/detail'
import { WarehouseProvider } from './context/WarehouseProvider'
import MaterialTransfer from './pages/ArrivalPlan/MaterialTransfer'
import DetailMaterialTransfer from './pages/ArrivalPlan/MaterialTransfer/Detail'
import WorkorderJobStatus from './pages/WorkOrderPlan/job-status'
import WorkorderDetailJobStatus from './pages/WorkOrderPlan/job-status/detail'
import MaterialRejectPage from './pages/Inbound/MaterialReject'
import CreateMaterialRejectPage from './pages/Inbound/MaterialReject/create'
import MaterialRejectDetailPage from './pages/Inbound/MaterialReject/detail'
import InboundReturn from './pages/Inbound/InboundReturn'
import InboundReturnDetail from './pages/Inbound/InboundReturn/detail'
import StockTake from './pages/StockTake'
import CreateStockTake from './pages/StockTake/create'
import DetailStockTake from './pages/StockTake/detail'
import TakeDetail from './pages/StockTake/takeDetail'
import RequestReturn from './pages/Outbound/RequestReturn'
import DetailRequestReturn from './pages/Outbound/RequestReturn/detail'
import CreatePurchaseOrderPacking from './pages/Inbound/PurchaseOrderPacking/create'
import DetailPurchaseOrderPacking from './pages/Inbound/PurchaseOrderPacking/detail'
import StockInfoPacking from './pages/StockInfoPacking'
import StockOpnamePacking from './pages/StockOpnamePacking'
import StockOpnamePackingCreate from './pages/StockOpnamePacking/create'
import StockOpnamePackingDetail from './pages/StockOpnamePacking/detail'
import WorkOrderRepack from './pages/WorkOrderPlan/repack'
import WorkOrderRepackDetail from './pages/WorkOrderPlan/repack/detail'
import WorkOrderRepackCreate from './pages/WorkOrderPlan/repack/create'
import CreateReceiveAtWarehousePlan from './pages/ArrivalPlan/ReceiveAtWarehousePlan/create'
import CreateMaterialTransfer from './pages/ArrivalPlan/MaterialTransfer/create'
import StockOpnameCycleCount from './pages/StockOpnameCycleCount'
import StockOpnameCycleCountCreate from './pages/StockOpnameCycleCount/create'
import StockOpnameCycleCountDetail from './pages/StockOpnameCycleCount/detail'
import StockOpnameCycleCountSlotDetail from './pages/StockOpnameCycleCount/slotDetail'
import ReplenishmentPage from './pages/Replenishment'
import CreateReplenishmentPage from './pages/Replenishment/create'
import DetailReplenishmentPage from './pages/Replenishment/detail'
import StockLedgerPage from './pages/StockLedger'
import CreateManualStockOpname from './pages/ManualStockOpname/create'
import ManualStockOpname from './pages/ManualStockOpname'
import ManualStockOpnameDetail from './pages/ManualStockOpname/detail'
import ManualStockOpnameItemDetail from './pages/ManualStockOpname/itemDetail'
import SlotDetailPage from './pages/Master/SlotDetail'
import DetailSlotPage from './pages/Master/SlotDetail/detail'
import SamplingTimbang from './pages/Inbound/SamplingTimbang/Index'
import AppErrorBoundary from './components/ErrorBoundary'

function App() {
  const [state] = useContext(UserContext)
  return (
    <AppErrorBoundary>
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <WarehouseProvider>
          <NotificationProvider>
            <Routes>
              <Route
                exact
                path="/"
                element={
                  !state.login ? (
                    <Login />
                  ) : (
                    <Navigate to="/dashboard" replace />
                  )
                }
              />
              <Route
                element={
                  !state.login ? (
                    <Navigate to="/" replace />
                  ) : state.username.role.role_code === 'PnP' ? (
                    <Navigate to="/mover" />
                  ) : (
                    <PrivateRoutes />
                  )
                }
              >
                <Route exact path="/dashboard" element={<Dashboard />}>
                  <Route index element={<HomeDashboard />} />
                </Route>
                <Route exact path="/master/" element={<Dashboard />}>
                  <Route exact path="categories" element={<MasterCategory />} />
                  <Route
                    exact
                    path="business-units"
                    element={<MasterBusinessUnit />}
                  />
                  <Route exact path="items" element={<MasterItemPage />} />
                  <Route exact path="rack-details">
                    <Route exact index element={<MasterRackDetailPage />} />
                    <Route
                      exact
                      path="detail/:slotId"
                      element={<DetailMasterRackDetailPage />}
                    />
                  </Route>
                  <Route exact path="slot-details">
                    <Route exact index element={<SlotDetailPage />} />
                    <Route
                      exact
                      path="detail/:slotId"
                      element={<DetailSlotPage />}
                    />
                  </Route>
                  <Route exact path="area" element={<MasterArea />} />
                  <Route exact path="batch" element={<MasterBatchPage />} />
                  <Route exact path="vehicle" element={<MasterVehicle />} />
                  <Route
                    exact
                    path="items/:code"
                    element={<MasterItemDetailPage />}
                  />
                  <Route
                    exact
                    path="expedition"
                    element={<MasterExpedition />}
                  />
                  <Route exact path="branch" element={<MasterBranch />} />
                  <Route exact path="sector" element={<MasterSector />} />
                  <Route exact path="driver" element={<MasterDriver />} />
                  <Route exact path="user" element={<MasterUserPage />} />
                  <Route exact path="role" element={<MasterRolePage />} />
                  <Route exact path="access" element={<MasterAccessPage />} />
                  <Route exact path="pallete" element={<MasterPallete />} />
                  <Route exact path="stock" element={<MasterStock />} />
                  <Route
                    exact
                    path="stock/:code"
                    element={<MasterStockDetail />}
                  />
                  <Route
                    exact
                    path="stock/detail/:id"
                    element={<MasterStockQuarantineRejectPage />}
                  />
                  <Route
                    exact
                    path="stock/send-to-quarantine"
                    element={<SendToQuarantinePage />}
                  />
                </Route>
                <Route exact path="/purchase-order/" element={<Dashboard />}>
                  <Route exact index element={<PurchaseOrder />} />
                  <Route
                    exact
                    path="detail/:code"
                    element={<PurchaseOrderDetail />}
                  />
                  <Route
                    exact
                    path="packing/create"
                    element={<CreatePurchaseOrderPacking />}
                  />
                </Route>
                <Route exact path="/inbound/" element={<Dashboard />}>
                  <Route
                    exact
                    path="purchase-order/create/:code"
                    element={<PurchaseReceiptCreate />}
                  />
                  <Route exact path="purchase-receipt">
                    <Route exact index element={<PurchaseReceipt />} />
                    <Route
                      exact
                      path="detail/packing/:id"
                      element={<DetailPurchaseOrderPacking />}
                    />
                    <Route
                      exact
                      path="sampling/:inbound_id"
                      element={<SamplingTimbang />}
                    />
                    <Route
                      exact
                      path=":id"
                      element={<PurchaseReceiptDetail />}
                    />
                  </Route>
                  <Route exact path="history">
                    <Route exact index element={<InboundHistoryPage />} />
                  </Route>
                  <Route exact path="ml">
                    <Route index element={<ReceiveMLIndex />} />
                    <Route
                      exact
                      path="detail/:id"
                      element={<ReceiveMLDetail />}
                    />
                  </Route>
                  <Route exact path="inbound-return">
                    <Route index element={<InboundReturn />} />
                    <Route
                      exact
                      path="detail/:id"
                      element={<InboundReturnDetail />}
                    />
                  </Route>
                  <Route exact path="material-reject">
                    <Route index element={<MaterialRejectPage />} />
                    <Route
                      exact
                      path="create"
                      element={<CreateMaterialRejectPage />}
                    />
                    <Route
                      exact
                      path="detail/:id"
                      element={<MaterialRejectDetailPage />}
                    />
                  </Route>
                </Route>
                <Route exact path="/arrival/" element={<Dashboard />}>
                  <Route
                    exact
                    path="purchase-receipt-plan"
                    element={<PurchaseReceiptPlan />}
                  />
                  <Route exact path="receive-at-warehouse-plan">
                    <Route exact index element={<ReceiveAtWarehousePlan />} />
                    <Route
                      exact
                      path="create"
                      element={<CreateReceiveAtWarehousePlan />}
                    />
                  </Route>
                  <Route exact path="material-transfer">
                    <Route index element={<MaterialTransfer />} />
                    <Route
                      exact
                      path="create"
                      element={<CreateMaterialTransfer />}
                    />
                    <Route
                      exact
                      path="detail/:id"
                      element={<DetailMaterialTransfer />}
                    />
                  </Route>
                </Route>
                <Route exact path="/setting/" element={<Dashboard />}>
                  <Route exact path="staging" element={<MasterStaging />} />
                  <Route exact path="upload" element={<UploadMap />} />
                  <Route exact path="editor" element={<MapEditor />} />
                  <Route exact path="racks" element={<MasterRackPage />} />
                  <Route
                    exact
                    path="racks/detail/:id"
                    element={<DetailRackPage />}
                  />
                </Route>
                <Route exact path="/manage/" element={<Dashboard />}>
                  <Route exact path="role" element={<ManageRolePage />} />
                  <Route
                    exact
                    path="role/create"
                    element={<CreateManageRolePage />}
                  />
                  <Route
                    exact
                    path="role/edit/:id"
                    element={<EditManageRolePage />}
                  />
                  <Route exact path="access" element={<ManageAccessPage />} />
                </Route>
                <Route exact path="/outbound/" element={<Dashboard />}>
                  <Route exact path="sj/" element={<SJ />} />
                  <Route exact path="sj/create" element={<CreateSj />} />
                  <Route
                    exact
                    path="sj/create/location"
                    element={<CreateSjLocation />}
                  />
                  <Route exact path="sj/detail/:id" element={<DetailSj />} />
                  <Route
                    exact
                    path="sj/detail/location"
                    element={<SlotLocation />}
                  />
                  <Route exact path="dc/" element={<DeliveryConfirmation />} />
                  <Route
                    exact
                    path="dc/:id"
                    element={<DeliveryConfirmationDetail />}
                  />
                  <Route exact path="plan/" element={<OutboundPlan />} />
                  <Route
                    exact
                    path="plan/detail/:code"
                    element={<DetailOutboundPlan />}
                  />
                  <Route
                    exact
                    path="plan/create"
                    element={<CreateOutboundPlan />}
                  />
                  <Route
                    exact
                    path="plan/create/detail"
                    element={<CreateDetailOutboundPlan />}
                  />
                  <Route exact path="history" element={<OutboundHistory />} />
                  <Route
                    exact
                    path="history/detail/:id"
                    element={<DetailSj />}
                  />
                  <Route
                    exact
                    path="history/detail/location"
                    element={<SlotLocation />}
                  />
                  <Route
                    exact
                    path="customer/delivery/plan"
                    element={<CustomerDeliveryPlan />}
                  />
                  <Route
                    exact
                    path="delivery-history"
                    element={<DeliveryHistory />}
                  />
                  <Route
                    exact
                    path="delivery-history/detail/:id"
                    element={<DeliveryHistoryDetail />}
                  />
                  <Route exact path="transfer/" element={<Transfer />} />
                  <Route
                    exact
                    path="transfer/detail/:id"
                    element={<DetailTransfer />}
                  />
                  <Route
                    exact
                    path="transfer/location"
                    element={<SlotLocationTr />}
                  />
                  <Route exact path="request-return">
                    <Route index element={<RequestReturn />} />
                    <Route
                      exact
                      path="detail/:code"
                      element={<DetailRequestReturn />}
                    />
                  </Route>
                </Route>
                <Route exact path="/workorder/" element={<Dashboard />}>
                  <Route exact path="plan">
                    <Route exact index element={<WorkOrderPlan />} />
                    <Route
                      exact
                      path="detail/:id"
                      element={<WorkOrderPlanDetail />}
                    />
                    <Route
                      exact
                      path="location"
                      element={<SLotLocationWorkOrderPlan />}
                    />
                  </Route>
                  <Route exact path="repack">
                    <Route exact index element={<WorkOrderRepack />} />
                    <Route
                      exact
                      path="create/:code"
                      element={<WorkOrderRepackCreate />}
                    />
                    <Route
                      exact
                      path="detail/:code"
                      element={<WorkOrderRepackDetail />}
                    />
                  </Route>
                  <Route exact path="job-status">
                    <Route index element={<WorkorderJobStatus />} />
                    <Route
                      exact
                      path="detail/:id"
                      element={<WorkorderDetailJobStatus />}
                    />
                  </Route>
                </Route>
                <Route exact path="/material-request" element={<Dashboard />}>
                  <Route exact index element={<MaterialRequest />} />
                  <Route
                    exact
                    path="/material-request/detail/:id"
                    element={<MaterialRequestDetail />}
                  />
                  <Route
                    exact
                    path="/material-request/create/:id"
                    element={<CreateMaterialRequest />}
                  />
                </Route>
                <Route exact path="/material-issue" element={<Dashboard />}>
                  <Route index element={<MaterialIssuePage />} />
                  <Route path="create" element={<CreateMaterialIssuePage />} />
                  <Route
                    path="detail/:id"
                    element={<MaterialIssueDetailPage />}
                  />
                </Route>
                <Route exact path="/disposal" element={<Dashboard />}>
                  <Route index element={<DisposalPage />} />
                  <Route path="create" element={<CreateDisposalPage />} />
                  <Route path="detail/:id" element={<DisposalDetailPage />} />
                </Route>
                <Route exact path="/transfer" element={<Dashboard />}>
                  <Route exact path="transfer-area">
                    <Route index element={<TransferAreaPage />} />
                    <Route
                      exact
                      path="detail/:id"
                      element={<DetailTransferAreaPage />}
                    />
                  </Route>
                  <Route exact path="transfer_antar_rak">
                    <Route index element={<TransferRackPage />} />
                    <Route
                      exact
                      path="create"
                      element={<CreateTransferRackPage />}
                    />
                    <Route
                      exact
                      path="detail/:id"
                      element={<DetailTransferRackPage />}
                    />
                  </Route>
                </Route>
                <Route exact path="/berita-acara" element={<Dashboard />}>
                  <Route index element={<BeritaAcaraPage />} />
                </Route>
                <Route exact path="/item-issue" element={<Dashboard />}>
                  <Route index element={<ItemIssue />} />
                  <Route
                    path="create-transfer"
                    element={<CreateTransferItemIssuePage />}
                  />
                </Route>
                <Route exact path="/stock-opname" element={<Dashboard />}>
                  <Route exact path="stock-take">
                    <Route index element={<StockTake />} />
                    <Route path="create" element={<CreateStockTake />} />
                    <Route path="detail/:id" element={<DetailStockTake />} />
                    <Route path="detail/:id/:slotId" element={<TakeDetail />} />
                  </Route>
                  <Route exact path="packing-stock-opname">
                    <Route index element={<StockOpnamePacking />} />
                    <Route
                      exact
                      path="create"
                      element={<StockOpnamePackingCreate />}
                    />
                    <Route
                      exact
                      path="detail/:id"
                      element={<StockOpnamePackingDetail />}
                    />
                  </Route>
                  <Route exact path="cycle-count">
                    <Route index element={<StockOpnameCycleCount />} />
                    <Route
                      path="create"
                      element={<StockOpnameCycleCountCreate />}
                    />
                    <Route
                      path="detail/:id"
                      element={<StockOpnameCycleCountDetail />}
                    />
                    <Route
                      path="slot/detail/:id/:slotId"
                      element={<StockOpnameCycleCountSlotDetail />}
                    />
                  </Route>
                  <Route exact path="manual-stock-opname">
                    <Route index element={<ManualStockOpname />} />
                    <Route
                      exact
                      path="create"
                      element={<CreateManualStockOpname />}
                    />
                    <Route
                      exact
                      path="detail/:id"
                      element={<ManualStockOpnameDetail />}
                    />
                    <Route
                      exact
                      path="detail/:opnameId/:id"
                      element={<ManualStockOpnameItemDetail />}
                    />
                  </Route>
                </Route>
                <Route exact path="/stock-adjustment" element={<Dashboard />}>
                  <Route index element={<StockAdjustment />} />
                  <Route path="create" element={<CreateStockAdjustment />} />
                  <Route
                    path="detail/:id"
                    element={<DetailStockAdjustment />}
                  />
                </Route>
                <Route exact path="/replenishment" element={<Dashboard />}>
                  <Route index element={<ReplenishmentPage />} />
                  <Route
                    exact
                    path="create"
                    element={<CreateReplenishmentPage />}
                  />
                  <Route
                    exact
                    path="detail/:id"
                    element={<DetailReplenishmentPage />}
                  />
                </Route>
                <Route exact path="/stock-ledger" element={<Dashboard />}>
                  <Route index element={<StockLedgerPage />} />
                </Route>
                <Route exact path="/notification" element={<Dashboard />}>
                  <Route exact path="" element={<Notification />} />
                </Route>
                <Route exact path="/stock-info-packing" element={<Dashboard />}>
                  <Route exact index element={<StockInfoPacking />} />
                </Route>
              </Route>

              <Route
                element={
                  !state.login ? (
                    <Navigate to="/" replace />
                  ) : state.username.role.role_code === 'PnP' ? (
                    <ProtectedMoverRoutes />
                  ) : (
                    <PrivateRoutes />
                  )
                }
              >
                <Route exact path="/mover" element={<DashboardMover />}>
                  <Route exact index element={<IndexMover />} />
                </Route>
              </Route>
            </Routes>
          </NotificationProvider>
        </WarehouseProvider>
      </BrowserRouter>
    </AppErrorBoundary>
  )
}

export default App
